import React from 'react'

import './portfolio.css'

import images from '../../assets'

const Portfolio = () => {
  return (
    <div className='lsk__portfolio'>
        <h1>Nossos Serviços</h1>
        <div className='lsk__portfolio-items'>
            <div className='lsk_portfolio-item'>
                <img src={images.ie} alt='infrastructure' id="infrastructure"></img>
                <h2>Infraestrutura</h2>
                <p>Planejamos, implementamos e fazemos a gestão da sua infraestrutura on-premises e/ou cloud aplicando 
                   as melhores práticas e metodologias de ITSM, garantindo estabilidade, resiliência e suporte.
                </p>
                <span className='lsk__portfolio-content-button'>
                  <button type='button'>Saiba mais </button>
              </span>
            </div>
            <div className='lsk_portfolio-item'>
                <img src={images.devops} alt='devops'></img>
                <h2>DevOps</h2>
                <p>Aplicando as melhores práticas de arquitetura e segurança, nós construimos e operamos arquiteturas
                  modernas de microserviços de alta disponibilidade, escalabilidade e resiliência.  
                </p>
                <span className='lsk__portfolio-content-button'>
                  <button type='button'>Saiba mais </button>
              </span>
            </div>
            <div className='lsk_portfolio-item'>
                <img src={images.se} alt='softwareengineering'></img>
                <h2>Engenharia de Software</h2>
                <p>Planejamos, desenvolvemos e entregamos aplicações de alta qualidade e desempenho, aplicando metodologias
                  ágeis, garantindo entregas eficientes e assertivas. Nossos engenheiros são capazes de assumir os projetos 
                  para atingir os objetivos do negócio.
                </p>
                <span className='lsk__portfolio-content-button'>
                  <button type='button'>Saiba mais </button>
              </span>
            </div>
        </div>
    </div>
  )
}

export default Portfolio